if (!customElements.get('sticky-cta-timer')) {
  class StickyCTATimer extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        this.init();
      });
    }

    init() {
      const year = Number(this.dataset.year);
      const month = Number(this.dataset.month) - 1;
      const day = Number(this.dataset.day);
      const hour = Number(this.dataset.hour);
      const minute = Number(this.dataset.minute);


      this.targetDate = new Date(
        year,
        month,
        day,
        hour,
        minute,
        0
      );

      this.hoursEl = this.querySelector('.hours');
      this.minutesEl = this.querySelector('.minutes');
      // this.secondsEl = this.querySelector('.seconds');

      if (

        !this.hoursEl ||
        !this.minutesEl
      ) {
        return;
      }

      this.updateTimer();

      this.interval = setInterval(() => {
        this.updateTimer();
      }, 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    updateTimer() {
      const now = Date.now();
      const distance = this.targetDate.getTime() - now;

      if (distance <= 0) {
        this.updateValues(0, 0, 0);
        clearInterval(this.interval);
        return;
      }

      const totalHours = Math.floor(distance / 3600000);

      const minutes = Math.floor(
        (distance % 3600000) / 60000
      );

      const seconds = Math.floor(
        (distance % 60000) / 1000
      );

      this.updateValues(
        totalHours,
        minutes,
        seconds
      );
    }

    updateValues(hours, minutes, seconds) {
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      // this.secondsEl.textContent = String(seconds).padStart(2, '0');

      if (hours === 0 && minutes === 0) {
        this.classList.add('hidden');
      } else {
        this.classList.remove('hidden');
      }
    }
  }

  customElements.define('sticky-cta-timer', StickyCTATimer);
}

document.addEventListener("DOMContentLoaded", () => { 
  const stickyBar = document.getElementById("DesktopStickyCTA");
  const trigger = document.querySelector(".reason-img-text-section");

  if (!stickyBar || !trigger) return;

  function toggleSticky() {
    const rect = trigger.getBoundingClientRect();

    if (rect.top <= 0) {
      stickyBar.classList.add("show");
      stickyBar.setAttribute("aria-hidden", "false");
    } else {
      stickyBar.classList.remove("show");
      stickyBar.setAttribute("aria-hidden", "true");
    }
  }

  toggleSticky();

  window.addEventListener("scroll", toggleSticky, {
    passive: true
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const stickyBar = document.getElementById("DesktopStickyCTA");
  const sections = document.querySelectorAll(".reason-img-text-section");

  if (!stickyBar || !sections.length) return;

  const firstSection = sections[0];
  const lastSection = sections[sections.length - 1];

  function toggleSticky() {
    const firstRect = firstSection.getBoundingClientRect();
    const lastRect = lastSection.getBoundingClientRect();

    const passedFirst = firstRect.top <= 0;
    const passedLast = lastRect.bottom <= 0;

    if (passedFirst && !passedLast) {
      stickyBar.classList.add("show");
      stickyBar.setAttribute("aria-hidden", "false");
    } else {
      stickyBar.classList.remove("show");
      stickyBar.setAttribute("aria-hidden", "true");
    }
  }

  toggleSticky();

  window.addEventListener("scroll", toggleSticky, {
    passive: true
  });
});